import React from "react";
import { Barras, COLORES, Columnas, Kpis, Mezcla, Pagina, Tabla, Tarjeta, fmtM, fmtN, useDatos, usePeriodo } from "./comun";

function ReporteCompras() {
  const periodo = usePeriodo();
  const { datos: d, error } = useDatos(`/compras/${periodo.inicio}/${periodo.fin}`);
  const k = d?.kpis;
  return (
    <Pagina titulo="Compras" subtitulo="Que se ha recibido y que falta por llegar" periodo={periodo} error={error} cargando={!d}>
      {d && <>
        <Kpis items={[
          { t: "Comprado", v: fmtM(k.comprado), d: `${fmtN(k.recepciones)} recepciones` }, { t: "Botellas recibidas", v: fmtN(k.botellas) }, { t: "Costo por botella", v: fmtM(k.costoBotella) },
          { t: "Por recibir", v: `${fmtN(k.pendiente)} bot.` }, { t: "Ordenes atrasadas", v: fmtN(k.ordenesAtrasadas), tono: k.ordenesAtrasadas ? "baja" : "" },
        ]} />
        <div className="rp-grid">
          <Tarjeta titulo="Compras por mes" ancho><Columnas datos={d.meses} series={[{ key: "importe", label: "Compras", color: COLORES[0] }]} /></Tarjeta>
          <Tarjeta titulo="Por proveedor"><Mezcla datos={d.porProveedor} valor="importe" /></Tarjeta>
          <Tarjeta titulo="Por region"><Barras datos={d.porRegion} valor="importe" /></Tarjeta>
          <Tarjeta titulo="Vinos mas comprados"><Barras datos={d.topVinos} valor="importe" extra={(x) => `${fmtN(x.botellas)} bot.`} /></Tarjeta>
          <Tarjeta titulo="Ordenes abiertas" nota="Primero las mas atrasadas">
            <Tabla filas={d.abiertas} columnas={[{ t: "OC", k: "oc" }, { t: "Proveedor", k: "proveedor" }, { t: "Compromiso", k: "compromiso" }, { t: "Pendiente", k: "pendiente", f: fmtN, n: 1 }, { t: "Dias atraso", k: "diasAtraso", f: fmtN, n: 1 }]} />
          </Tarjeta>
        </div>
      </>}
    </Pagina>
  );
}
export default ReporteCompras;
